export default class Slider extends HTMLElement {
  constructor(swiperParams) {
    super();
    this.swiperParams = swiperParams;
  }

  connectedCallback() {
    this.initSlider();
    this.themeEditorEvents();
  }

  initSlider() {
    this.swiperContainer = this.querySelector('swiper-container');

    Object.assign(this.swiperContainer, this.swiperParams);

    customElements.whenDefined('swiper-container').then(() => {
      this.swiperContainer.initialize();
      this.swiper = this.swiperContainer.swiper;
      this?.initialized?.();
    });
  }

  updateSwiperParams(newParams) {
    this.swiperParams = { ...this.swiperParams, ...newParams };

    if (!this.swiperContainer) return;
    Object.assign(this.swiperContainer, this.swiperParams);

    if (!this.swiper) return;
    this.swiper.update();
  }

  themeEditorEvents() {
    document.addEventListener('shopify:section:load', () => {
      if (this.swiper) {
        this.swiper.destroy();
        this.initSlider();
      }
    });
  }
}
